import React, { useState, useContext, FunctionComponent, CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import { Dialog, Box, Typography, IconButton, SxProps, TextField  } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import Check from '@mui/icons-material/Check';

// Custom
import { QRCodeSVG } from 'qrcode.react';
import DialogBody from '@/ui/Dialog/DialogBody';
import DialogHeader from '@/ui/Dialog/DialogHeader';
import { IDialogProps } from '@/@types/ui/DialogContext';
import DialogToolbarButtonClose from '../Dialog/ToolbarButtons/DialogToolbarButtonClose';

import DialogContext from '@/ui/DialogContext/DialogContext';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  } as CSSProperties,
  textField: { width: '98%', margin: '11px' } as SxProps,
};

const PublicShareDialog: FunctionComponent<IDialogProps> = (props) => {
  const { url, record, type, subtype } = props;

  const [isCopied, setIsCopied] = useState(false);

  const dialogContext = useContext(DialogContext);

  const { t } = useTranslation();

  const naziv = record?.naziv ? (record.naziv as string) : '';

  const handleDialogClose = () => {
    dialogContext.hideDialog();
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(url);
    setIsCopied(true);
  };

  return (
    <Dialog fullWidth open>
      <DialogHeader>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6" sx={{ color: '#DDFFD7', marginTop: 0.5 }}>
            {t('buttons.share')}
          </Typography>
          <DialogToolbarButtonClose onClick={(evt) => handleDialogClose()} />
        </Box>
      </DialogHeader>
      <DialogBody>
        <Box flex={1} mt={2} display="flex" flexDirection="row" justifyContent="space-between">
          <Box mr={5} display="flex" flexDirection="column" width="100%">
            <Typography ml={2} mt={3} variant="body1">
              <b>{naziv}</b>
            </Typography>
            <TextField
              variant="outlined"
              fullWidth
              value={url}
              onFocus={(event) => {
                event.target.select();
              }}
              sx={styles.textField}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton onClick={handleCopyClick} disabled={isCopied} edge="end">
                    {isCopied ? <Check sx={{ color: 'green' }} /> : <ContentCopy />}
                  </IconButton>
                ),
              }}
            />
          </Box>
          <QRCodeSVG value={url} />
        </Box>
      </DialogBody>
    </Dialog>
  );
};

export default PublicShareDialog;
